import { motion } from "framer-motion";
import React from "react";
import { Box } from "~/design-system/Box";
import { useBreakpoint } from "~/design-system/hooks";
import { Inline } from "~/design-system/Inline";
import { Placeholder } from "~/design-system/Placeholder";
import { SafeArea } from "~/design-system/SafeArea";
import { Stack } from "~/design-system/Stack";

const Header = () => {
  return (
    <Box
      display="flex"
      justifyContent="flexStart"
      alignItems="center"
      width="full"
      marginBottom="large"
      marginTop="medium"
    >
      <Placeholder height="xsmall" width="small" borderRadius="small" />
      <Placeholder
        marginLeft="small"
        height="xsmall"
        width="full"
        borderRadius="small"
      />
      <Placeholder
        marginLeft="small"
        height="xsmall"
        width="large"
        borderRadius="small"
      />
    </Box>
  );
};

const TaskRow = () => {
  const { breakpoint } = useBreakpoint();

  return (
    <Box
      display="flex"
      justifyContent="flexStart"
      alignItems="flexStart"
      width="full"
      marginBottom="medium"
    >
      <Placeholder
        flexGrow={1}
        flexShrink={0}
        height="small"
        width="small"
        borderRadius="full"
      />
      <Stack
        align="left"
        width="full"
        css={{
          marginLeft: "$space$4",
        }}
      >
        <Placeholder height="xsmall" width="full" borderRadius="small" />
        <Inline
          alignY="top"
          space="small"
          width="full"
          css={{
            "& > *": {
              marginTop: 0,
            },
            marginTop: "$space$2",
          }}
        >
          {!!Math.round(Math.random()) && (
            <Placeholder height="xsmall" width="small" borderRadius="small" />
          )}
          {!!Math.round(Math.random()) && (
            <Placeholder height="xsmall" width="medium" borderRadius="small" />
          )}
          {!!Math.round(Math.random()) && (
            <Placeholder height="xsmall" width="small" borderRadius="small" />
          )}
        </Inline>
      </Stack>
      {!(breakpoint === "mobile") && (
        <>
          {!!Math.round(Math.random()) && (
            <Placeholder
              marginLeft="small"
              height="small"
              width="small"
              borderRadius="small"
              flexGrow={1}
              flexShrink={0}
            />
          )}
          {!!Math.round(Math.random()) && (
            <Placeholder
              marginLeft="small"
              height="small"
              width="small"
              borderRadius="small"
              flexGrow={1}
              flexShrink={0}
            />
          )}
        </>
      )}
    </Box>
  );
};

const TasksListSkeleton = () => {
  const { breakpoint } = useBreakpoint();

  const MIN_ROWS = 5;
  const MAX_ROWS = 12;

  const randomArray = Array.from({
    length: Math.floor(Math.random() * MAX_ROWS) + MIN_ROWS,
  });

  return (
    <motion.div
      style={{
        alignItems: "flex-start",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        justifyContent: "flex-start",
        width: "100%",
      }}
      initial={{ opacity: 0.4 }}
      animate={{ opacity: 1 }}
      transition={{
        duration: 0.6,
        ease: "easeIn",
        repeat: Infinity,
        repeatType: "mirror",
      }}
    >
      <SafeArea top />
      {!(breakpoint === "mobile") && <Header />}
      {randomArray.map((el, index) => {
        return <TaskRow key={index} />;
      })}
    </motion.div>
  );
};

export { TasksListSkeleton };
